import { render, staticRenderFns } from "./AdminDeviceTypes.vue?vue&type=template&id=5a4ff6a7&"
import script from "./AdminDeviceTypes.vue?vue&type=script&lang=ts&"
export * from "./AdminDeviceTypes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports